import { render, staticRenderFns } from "./PositivesNegatives.vue?vue&type=template&id=4ab1d49c&"
import script from "./PositivesNegatives.vue?vue&type=script&lang=ts&"
export * from "./PositivesNegatives.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab1d49c')) {
      api.createRecord('4ab1d49c', component.options)
    } else {
      api.reload('4ab1d49c', component.options)
    }
    module.hot.accept("./PositivesNegatives.vue?vue&type=template&id=4ab1d49c&", function () {
      api.rerender('4ab1d49c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/syndrome/PositivesNegatives.vue"
export default component.exports